import type { Id } from '@contracts/common';

/**
 * A person's presence colour (AI S1 spec §8.3.5 "Màu presence theo người", D203): their id picks one of eight
 * tokens, `--h-presence-1…8` in tokens.css, so the same person has the same colour on every board, every tab and
 * every screen. Their avatar, their outline on a card, and their Hana's badge, card tag and ghost cards all use it;
 * `--h-presence-ink` is the text drawn on it.
 */

export const PRESENCE_SLOTS = 8;

/**
 * The app has no dark card token yet: the dark presence tokens are checked against this card colour (a dark navy
 * surface, `hsl(222 20% 11%)`) until one exists (D203).
 */
export const DARK_CARD_REFERENCE = '222 20% 11%';

/** FNV-1a, 32 bits, over the id's UTF-16 code units: fast, stable and well spread for sequential ids. */
function fnv1a(text: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

/** The person's slot, 1 to 8. Ids are compared lowercase everywhere, so the colour is too. */
export function presenceSlot(userId: Id): number {
  return (fnv1a(userId.toLowerCase()) % PRESENCE_SLOTS) + 1;
}

/** The person's colour as a value for `--peer`: channels, read with `hsl(var(--peer))`. */
export function presenceVar(userId: Id): string {
  return `var(--h-presence-${presenceSlot(userId)})`;
}
